import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UrlParamsService {
    private changed = new Subject<boolean>();

    get onChanged() {
        return this.changed.asObservable();
    }

    private _params: ParamMap;
    get params() {
        return this._params;
    }

    private _entityType: string;
    get entityType() {
        return this._entityType;
    }

    private _location: string;
    get location() {
        return this._location;
    }

    private _id: string;
    get id() {
        return this._id;
    }

    constructor() { }

    setParams(params) {
        this._params = params;
        this._entityType = params.get('type');
        this._location = params.get('location');
        this._id = params.get('id');
        this.changed.next(true);
    }
}
